var BloominMenu = require('blooming-menu');
var $ = require('jquery');
var MainMenu = /** @class */ (function () {
    function MainMenu() {
        this.initialized = false;
        //Setup of the action menu
        this.menu = new BloominMenu({
            itemsNum: 11,
            startAngle: 165,
            endAngle: 15,
            radius: 315,
            fatherElement: $('#path-container')[0],
            animationDuration: 0.1
        });
        //Inner mapping of menu entries
        this.opMap = {
            select: {
                index: 0,
                selectable: true,
                selectableCursor: 'pointer'
            },
            rotate: {
                index: 1,
                selectable: true,
                selectableCursor: 'wait'
            },
            scale: {
                index: 2,
                selectable: true,
                selectableCursor: 'nesw-resize'
            },
            paint: {
                index: 3,
                selectable: true
            },
            stackdown: {
                index: 4,
                selectable: false
            },
            stackup: {
                index: 5,
                selectable: false
            },
            shadow: {
                index: 6,
                selectable: false
            },
            delete: {
                index: 7,
                selectable: false
            },
            plus: {
                index: 8,
                selectable: false
            },
            download: {
                index: 9,
                selectable: false
            },
            light: {
                index: 10,
                selectable: true,
                selectableCursor: 'default'
            }
        };
    }
    MainMenu.prototype.enablePathOperations = function (enable) {
        this.enableItems([
            this.opMap.rotate,
            this.opMap.scale,
            this.opMap.stackdown,
            this.opMap.stackup,
            this.opMap.shadow,
            this.opMap.delete
        ], enable);
    };
    /**
     * Enables/Disables the given menu entries
     * @param list A list of index corresponding to the menu item index in the list
     * @param enabled If we've to enable to disable the entries
     */
    MainMenu.prototype.enableItems = function (list, enabled) {
        for (var index in list) {
            var htmlEntry = this.getItem(list[index]);
            if (enabled) {
                htmlEntry.addClass('enabled');
            }
            else {
                htmlEntry.removeClass('enabled');
            }
        }
    };
    /**
     * Visually selects the requested item based on the given item index
     * in the menu items list
     * @param index The index of the entry to select
     */
    MainMenu.prototype.selectItem = function (item) {
        if (this.selectedOperation !== undefined) {
            this.selectedOperation.removeClass('selected');
        }
        this.selectedOperation = this.getItem(item);
        this.selectedOperation.addClass('selected');
        $('.imageEntry').css('cursor', item.selectableCursor);
    };
    /**
     * Renders the menu and binds the events. If the menu has already been
     * rendered, then this function is a no-op.
     */
    MainMenu.prototype.setupMenu = function () {
        if (this.initialized) {
            return;
        }
        this.menu.render();
        this.menu.open();
        //Unbind of all internal events on the menu as we want to keep the menu
        //opened forever
        this.unbindLibraryEvents();
        //Definition of all behaviors when clicking on the menu items
        this.bindBehaviors();
        this.enableItems([
            this.opMap.select,
            this.opMap.plus,
            this.opMap.download,
            this.opMap.light,
            this.opMap.paint
        ], true);
        this.getItem(this.opMap.select).click();
        this.initialized = true;
    };
    /**
     * Removes initial close events added by the library itself
     */
    MainMenu.prototype.unbindLibraryEvents = function () {
        var me = this;
        this.menu.props.elements.items.forEach(function (item, index) {
            item.removeEventListener('click', me.menu._handlers['item' + index]);
        });
    };
    /**
     * Retrieves the jquery object associated with the given menu index
     * @param index The index in the menu list
     */
    MainMenu.prototype.getItem = function (item) {
        return $(this.menu.props.elements.items[item.index]);
    };
    /**
     * Binds events such that external listeners can make some operations
     * when the user clicks on the menu entries. The triggered event will
     * be named based on the operation (move, rotate, etc..)
     */
    MainMenu.prototype.bindBehaviors = function () {
        var me = this;
        var _loop_1 = function (mapKey) {
            var item = this_1.opMap[mapKey];
            var htmlElement = this_1.getItem(item);
            htmlElement.on('click', function () {
                if (htmlElement.hasClass('enabled')) {
                    $('.blooming-menu__container').trigger(mapKey);
                    if (item.selectable) {
                        me.selectItem(item);
                    }
                }
            });
        };
        var this_1 = this;
        for (var mapKey in this.opMap) {
            _loop_1(mapKey);
        }
    };
    return MainMenu;
}());
export { MainMenu };
